<mat-expansion-panel [expanded]="initialExpanded" (opened)="toggleExpanded()" (closed)="toggleExpanded()"
    class="darkest">
    <mat-expansion-panel-header>
        <mat-panel-title>AI REQUESTS
            <mat-icon class="m-l-10 m-b-5"
                matTooltip="Click on an existing AI event to generate further documents related to that AI event">
                info
            </mat-icon>
            <mat-icon *ngIf="canDownloadRecordings" class="m-l-10 m-b-5 pointer" (click)="recoverRecordings($event)"
                matTooltip="You can recover AI recordings by clicking on this icon.">
                cloud_download
            </mat-icon>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="ai-request-info">
        <ng-container *ngIf="requestData; else listLoading">
            <ng-container *ngIf="requestData.length; else noResults">
                <ng-container *ngFor="let group of requestData">
                    <div class="list-header ai-feature">
                        {{ group.date | date: 'longDate' }}
                    </div>
                    <mat-list class="full-width">
                        <ng-container *ngFor="let item of group.items">
                            <mat-list-item (click)="loadRequest(item)" class="auto-height">
                                <div class="ai-request-item">
                                    <mat-icon svgIcon="medic_ai_highlight" class="m-r-20 list-avatar"></mat-icon>
                                    <div class="ai-request-details">
                                        <div class="checklist-container">

                                            <div class="checklist-item">
                                                <span class="m-r-10">
                                                    {{item.suggestedNoteTitle || 'AI Encounter'}}
                                                </span>
                                            </div>

                                        </div>

                                        <div matLine class="ai-request-footer">
                                            <div>Created By: {{ item.createdBy }} at {{ item.createdAt | date :
                                                'HH:mm'}}</div>
                                        </div>

                                    </div>
                                    <div class="view-icon">
                                        <mat-icon>chevron_right</mat-icon>
                                    </div>
                                </div>
                            </mat-list-item>
                        </ng-container>
                    </mat-list>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</mat-expansion-panel>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No results found.</p>
</ng-template>